import { Env, isEnv } from './types';

export const ARCADE_ROOT = '/arcadeapi/services/v1';

export function apiRootUrl( env, umbrella, domainName ) {
    if ( isEnv( env ) ) {
        if ( umbrella && window.location.hostname === 'localhost' ) {
            return 'https://qa.elevate-recognition.com/api';
        }
        if ( umbrella ) {
            const hostname =  window.location.hostname;
            return `https://${ domainName ? domainName : hostname }/api`;
        }
        const isProd = env === 'prod';
        const envPrefix = isProd ? '' : `${ env }.`;
        return `https://${ envPrefix }api.biw.cloud`;
    }
    throw new Error( `Illegal environment ${ env }` );
}

export function gameRomUrl( env, romId, umbrella, domainName ) {
    if ( env === Env.LOCAL ) {
        return '/game.zip';
    } else {
        return `${ apiRootUrl( env, umbrella, domainName ) }${ ARCADE_ROOT }/roms/${ encodeURIComponent( romId ) }/file`;
    }
}
